import React, { useState, useEffect } from "react";
import ARROW_IMAGE from "../../assets/images/Home/footer_crop.png";
import emailjs from "@emailjs/browser";
import { toast } from "react-toastify";

const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

const NewsLetter = () => {
  const [email, setEmail] = useState("");
  const [submitted, setSubmitted] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  useEffect(() => {
    // Make sure emailjs is initialized once
    emailjs.init("PXhuBkpQsLGvZ7daX");
  }, []);

  const handleChange = (e) => {
    setEmail(e.target.value);
    setError("");
  };

  const validateEmail = (value) => {
    if (!value) return "Email is required";
    if (!EMAIL_REGEX.test(value)) return "Enter a valid email";
    return "";
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const validationMessage = validateEmail(email);
    if (validationMessage) {
      setError(validationMessage);
      toast.error(validationMessage);
      return;
    }

    setLoading(true);
    setError("");
    try {
      const serviceId = "service_1dja0i8";
      const templateId = "template_m3vbn59";
      const templateParams = {
        email: email,
        message: "Newsletter Subscription Request",
        name: "Newsletter Subscriber",
      };

      await emailjs.send(serviceId, templateId, templateParams);
      setSubmitted(true);
      setEmail("");
      toast.success("Subscribed! Thank you.");
      setTimeout(() => setSubmitted(false), 3000);
    } catch (err) {
      setError("There was an issue subscribing. Please try again.");
      toast.error("There was an issue subscribing. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div
      className="py-10 newsletter-container-images flex items-center"
      style={{
        backgroundImage: `url(${ARROW_IMAGE})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
        minHeight: "300px",
        position: "relative",
        zIndex: 1,
        backgroundColor: "#f0f0f0",
      }}
    >
      <div className="max-w-screen-xl mx-auto px-4 sm:px-6 flex flex-col md:flex-row items-center justify-center md:justify-between w-full">
        {/* Left: Text */}
        <div className="w-full md:w-1/2 mb-8 md:mb-0 text-center md:text-left flex flex-col items-center md:items-start">
          <h2 className="text-xl font-extraboldd text-gray-700 sm:text-4xl">
            Get in Touch
          </h2>
          <p className="mt-4 text-lg leading-6 text-gray-600">
            Stay updated with the latest news and offers
          </p>
        </div>
        {/* Right: Form */}
        <div className="form-container-newsletter w-full md:w-1/2 flex justify-center md:justify-end">
          <form
            className="mt-8 md:mt-0 flex justify-center w-full max-w-2xl"
            onSubmit={handleSubmit}
            noValidate
          >
            <div className="relative w-full flex justify-center">
              <div className="w-[80%] relative">
                <input
                  type="email"
                  value={email}
                  onChange={handleChange}
                  className={`w-full px-5 py-3 border ${
                    error ? "border-red-500" : "border-gray-300"
                  } rounded-md focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 pr-32`}
                  placeholder="Enter your email"
                  aria-label="Email address"
                  required
                  disabled={submitted || loading}
                  style={{ paddingRight: "120px" }}
                />
                <button
                  type="submit"
                  className="absolute top-1/2 right-2 -translate-y-1/2 px-5 py-2 bg-[#fe7c0b] text-white font-medium rounded-md hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                  style={{ minWidth: "110px" }}
                  disabled={submitted || loading}
                >
                  {loading
                    ? "Sending..."
                    : submitted
                    ? "Thank you!"
                    : "Get in Touch"}
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default NewsLetter;
